module.exports = __webpack_public_path__ + "assets/d7c5fc9b6c7ab2d4295051fdf56639f3.jpg";